export const REJECTED_OPTIONS = [
  { value: 'Conflicting answers', text: 'Conflicting answers' },
  { value: 'Conflicting traits', text: 'Conflicting traits' },
  { value: 'Conflicting prequal', text: 'Conflicting prequal' },
  { value: 'Inappropriate', text: 'Inappropriate' },
  { value: 'Low quality', text: 'Low quality' },
  { value: 'Irrelevant', text: 'Irrelevant' },
  { value: 'Cleaning data', text: 'Cleaning data' },
  { value: 'Hate speech', text: 'Hate speech' },
  { value: 'ChatGPT/ AI', text: 'ChatGPT/ AI' },
  { value: 'other', text: 'Other' }
]

export const ANSWER_VARIANTS_COMMENTABLE = ['oex', 'hm', 'cn', 'dlv']

export const ORDER_BY_OPTIONS = [
  {
    value: 'id',
    text: 'Sorted by ID',
    isSimple: true,
    defaultOrder: 'asc',
    description: 'sort images by their respondent ID.'
  },
  {
    value: 'time',
    text: 'Sorted by time',
    isSimple: true,
    defaultOrder: 'asc',
    description: 'sort images by the date and time a respondent completed the survey.'
  },
  {
    value: 'sentiment',
    text: 'Sorted by sentiment',
    isSimple: false,
    defaultOrder: 'desc',
    description: 'if our AI powered sentiments feature was applied to this survey sort them positive to negative.',
    notForType: ['ir']
  },
  {
    value: 'length',
    text: 'Sorted by length',
    isSimple: false,
    defaultOrder: 'desc',
    description: 'sort by the character length of an open-ended response.',
    notForType: ['ir']
  },
  {
    value: 'kudos',
    text: 'Sorted by kudos',
    isSimple: true,
    defaultOrder: 'desc',
    description: 'if a kudos was given use this sort option to bring those to the top of the page.'
  },
  {
    value: 'similarity',
    text: 'Sorted by similarity',
    isSimple: true,
    defaultOrder: 'desc',
    description:
      'sort images by their similarities using AI technology. This works one question at a time. If you have multiple Image Response questions, use the drop-down to filter to a single question to sort by similarity.',
    forType: 'ir'
  }
]

export const ORDER_BY_OPTIONS_IMAGES = [
  {
    value: 'id',
    text: 'Sorted by ID',
    isSimple: true,
    defaultOrder: 'asc',
    description: 'sort images by their respondent ID.'
  },
  {
    value: 'time',
    text: 'Sorted by time',
    isSimple: true,
    defaultOrder: 'asc',
    description: 'sort images by the date and time a respondent completed the survey.'
  },
  {
    value: 'similarity',
    text: 'Sorted by similarity',
    isSimple: false,
    defaultOrder: 'desc',
    description:
      'sort images by their similarities using AI technology. This works one question at a time. If you have multiple Image Response questions, use the drop-down to filter to a single question to sort by similarity.',
    forType: 'ir'
  }
]

export const DEFAULT_ORDER_BY = 'id'
export const DEFAULT_ORDER_DIRECTION = ORDER_BY_OPTIONS.find(v => v.value == DEFAULT_ORDER_BY).defaultOrder

export const ORIGINALS = 'originals'
export const CORRECTIONS = 'corrections'
export const CORRECTED_SPELLING = 'corrected_spelling'

export const PER_PAGE_OPTIONS = [
  { value: 10, text: '10 per page' },
  { value: 50, text: '50 per page' },
  { value: 100, text: '100 per page' },
  { value: 250, text: '250 per page' }
]

export const PER_PAGE_OPTIONS_QA = [
  { value: 1, text: '1 per page' },
  { value: 50, text: '50 per page' },
  { value: 100, text: '100 per page' },
  { value: 250, text: '250 per page' }
]

export const PER_PAGE_OPTIONS_IMAGES = [
  { value: 12, text: '12 per page' },
  { value: 24, text: '24 per page' },
  { value: 48, text: '48 per page' },
  { value: 96, text: '96 per page' }
]

export const DEFAULT_QUERY = []

export const DEFAULT_PER_PAGE = 250
export const DEFAULT_PER_PAGE_QA = 50
export const DEFAULT_PER_PAGE_IMAGE_RESPONSES = 12
export const DEFAULT_PER_PAGE_VIDEO_RESPONSES = 10

export const DEFAULT_FETCH_TIMEOUT = 0
export const FETCH_TIMEOUT_STEP = 500
// A job the service keeps reporting as running is polled at most this far apart, for at most this
// long, and a single request that does not answer is given up on after the last; past the budget the
// page shows its error with a retry instead of loading for as long as it stays open.
export const MAX_FETCH_TIMEOUT = 3000
export const FETCH_POLL_BUDGET_MS = 3 * 60 * 1000
export const FETCH_REQUEST_TIMEOUT_MS = 30 * 1000
export const FETCH_TOO_LONG_MESSAGE = 'The comments are taking too long to load.'

export const HIDDEN_TAG_TYPES = [
  'comprehension',
  'complexity-flesch',
  'complexity',
  'sentiment-aws',
  'sentiment-manual',
  'sentiment-skipper'
]

export const ALLOWED_HTML_TAGS = /<(b|i|u)>.*<\/\1>|[!@#$%^&*(),.?":{}]|<br>/imu
export const PIPING_MASK_REGEX = /<b>\[([^\s]+)\]<\/b>|\[([^\s]+)\]/giu
export const JUNK_REGEX = /@junk/i

export const QUESTION_TITLE_PIPING_THUMB_WIDTH = 25
export const QUESTION_TITLE_PIPING_THUMB_HEIGHT = 25
export const QUESTION_TITLE_PIPING_IMAGE_WIDTH = 320
export const QUESTION_TITLE_PIPING_IMAGE_HEIGHT = 6000
export const QUESTION_TITLE_PIPING_IMAGE_MIN_WIDTH = 70
export const QUESTION_TITLE_PIPING_IMAGE_MAX_WIDTH = 265
export const QUESTION_TITLE_PIPING_IMAGE_MIN_HEIGHT = 70
export const QUESTION_TITLE_PIPING_IMAGE_MAX_HEIGHT = 265

export const kudosText =
  'Dear User,\n\nHello there! I just wanted to take a few moments to thank you for your awesome responses to the survey you completed on PaidViewpoint. All of us at aytm.com and PaidViewpoint are grateful for folks like you who truly make an effort when answering surveys. Your attentiveness and details in your answers are of utmost importance to our clients that use our service.\n\nWe are pleased to add our "pat on the back" bonus to your account, continue the great responses on PaidViewpoint!\n\nBest Regards,\n\nClare'

export const DEFAULT_COMMENT_STATUSES_STATE = {
  kudos: {},
  reject: {},
  approve: {},
  sentiment: {},
  tags: {}
}

export const DEFAULT_SELECTED_QUESTION = '*'

export const MASS_OPERATION_HASH = {
  update: 'TAG_MASS_UPDATED',
  create: 'TAG_MASS_ADDED',
  clone: 'TAG_MASS_CLONED',
  merge: 'TAG_MASS_MERGED',
  delete: 'TAG_MASS_REMOVED'
}

export const DEFAULT_SEARCH_STATE = {
  CSRF: null,
  pageData: [],
  tagsList: [],
  tagsData: {},
  processedQA: [],
  sentimentOptions: null,
  request: {
    query: DEFAULT_QUERY,
    selectedQuestion: DEFAULT_SELECTED_QUESTION,
    pageSize: DEFAULT_PER_PAGE,
    orderBy: DEFAULT_ORDER_BY,
    orderDirection: DEFAULT_ORDER_DIRECTION,
    currentPage: 1
  },
  correctionsLevel: ORIGINALS,
  qaCounter: null,
  qaTotal: null,
  qaAction: null,
  qaProcessedResponseId: null,
  totalPages: 0,
  totalComments: 0,
  totalImageResponses: 0,
  totalVideoResponses: 0,
  totalResponses: 0,
  totalRespondents: 0,
  totalVerbatims: 0,
  totalVerbatimsByLocale: {},
  translationsMissing: {},
  qaModeCounter: 0,
  errors: [],
  disabled: false,
  isAdmin: false,
  isSurveyOwner: false,
  isSurveyGuest: false,
  isQAMode: false,
  isQALoading: false,
  isLoading: true,
  isProcessing: false,
  isShowAllTraits: false,
  isShowAllTools: false,
  isShowSentiments: false,
  isResponseOrder: false,
  isPreserveState: false,
  isHighlightSearchTerms: true,
  isFetchDataNeeded: false,
  isTagsManagementDisabled: true,
  isSentimentsManagementDisabled: true,
  isQAModeDisabled: false,
  isQAModeDelayed: false,
  isUpdateQATotal: true
}

export const AytmLocale = {
  referenceWarning: 'REFERENCE WARNING',
  referenceError: 'REFERENCE ERROR',
  questionDoesntExist: "Referred field {index} doesn't exist in this survey",
  traitDoesntExist: "Referred field {index} doesn't exist in this survey",
  syntaxError: 'SYNTAX ERROR',
  clusterDoesntExist: "Referred cluster '{index}' doesn't exist for {scope}",
  notValidRule: '{rule} is not a valid aytm Logic rule',
  enableAutocomplete: 'To enable autocomplete press {hotkeys}',
  disableAutocomplete: 'To disable autocomplete press {hotkeys}'
}
